import React, { useEffect, useMemo } from 'react';

import { FormikValues, useFormik } from 'formik';

import {
  getSoftware,
  ISoftware,
  selectUserSoftware,
  updateSoftware,
  userActions,
} from '@pharmaplan/common';

import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import useDisableProfileSave from '../../../../hooks/useDisableProfileSave';

import { ICommonProfile } from '../General/General';
import ProfileForm from '../../ProfileForm';

const Softwares = ({ setSelected }: ICommonProfile) => {
  const dispatch = useAppDispatch();
  const softwares = useAppSelector(selectUserSoftware);

  const initialValue = useMemo(
    () =>
      softwares?.reduce(
        (obj: any, item: { softwareId: string; expLevel: number }) =>
          Object.assign(obj, { [item?.softwareId]: item?.expLevel ?? 1 }),
        {},
      ),
    [softwares],
  );

  const onSubmit = (values: FormikValues) => {
    const software = Object.keys(values)?.map((item) =>
      ({
        softwareId: item,
        expLevel: values[item as keyof typeof values] as number,
      }));
    dispatch(updateSoftware(software as ISoftware[]));
  };

  const formik = useFormik({
    initialValues: [],
    onSubmit,
    enableReinitialize: true,
  });

  useEffect(() => {
    dispatch(getSoftware());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    formik.setValues(initialValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [softwares]);

  const { disabled } = useDisableProfileSave({
    action: userActions.softwareUpdate,
    mutableValues: formik.values,
    initialValue,
  });

  return (
    <ProfileForm
      setSelected={setSelected}
      disableSave={disabled}
      selected="software"
      formik={formik}
    />
  );
};

export default Softwares;
